"use strict";

module.exports = {
  'name': 'column',
  'category': 'Matrix',
  'syntax': ['column(x, index)'],
  'description': 'Return a column from a matrix or array.',
  'examples': ['A = [[1, 2], [3, 4]]', 'column(A, 1)', 'column(A, 2)'],
  'seealso': ['row']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/matrix/column.js
// module id = 883
// module chunks = 0